
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { StockItem, StockItemData } from "@/types/cart";
import { InventoryItem } from "../components/InventoryTable";

export const useInventoryData = (selectedDate?: Date) => {
  return useQuery({
    queryKey: ["inventory_data", selectedDate],
    queryFn: async () => {
      console.log("Fetching inventory data for date:", selectedDate);
      
      let query = supabase
        .from("stock_items")
        .select("*")
        .order('date', { ascending: false });

      if (selectedDate) {
        const formattedDate = format(selectedDate, "yyyy-MM-dd", { locale: fr });
        console.log("Filtering by date:", formattedDate);
        query = query.eq("date", formattedDate);
      }

      const { data, error } = await query;

      if (error) {
        console.error("Error fetching inventory data:", error);
        throw error;
      }

      console.log("Retrieved inventory items:", data?.length || 0);

      const stockItems = (data || []).map(item => ({
        id: item.id,
        name: (item.data as StockItemData).Race || (item.data as StockItemData).name || 'N/A',
        systemQuantity: item.quantity || 0,
        countedQuantity: item.quantity || 0,
        difference: 0,
        notes: '',
        date: item.date,
        formattedDate: item.date ? 
          format(new Date(item.date), "EEEE d MMMM yyyy", { locale: fr }) : 
          format(new Date(item.created_at), "EEEE d MMMM yyyy", { locale: fr }),
      }));

      // Group items by date
      const groupedInventories = stockItems.reduce((acc: { [key: string]: InventoryItem[] }, item) => {
        const date = item.formattedDate || "";
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});

      console.log("Grouped inventories by date:", Object.keys(groupedInventories).length);

      return { groupedInventories, stockItems };
    },
  });
};
